import { ARABIC_SYMBOLS } from '@constants/currency';

import { Currency } from '@wegoTypes/currency';

export const getCurrencySymbolFontFamily = (currency: Currency, locale: string) => {
  if (!['AED', 'SAR'].includes(currency.code)) {
    // use default font
    return undefined;
  }

  return locale === 'ar' ? 'NotoNaskhArabic-Custom-AED-SAR' : 'Inter-Custom-AED-SAR';
};

export const checkIsSymbolFontLoaded = (currency: Currency, locale: string): boolean => {
  const symbolFontFamily = getCurrencySymbolFontFamily(currency, locale);

  return symbolFontFamily ? document.fonts.check(`1em ${symbolFontFamily}`) : true;
};

export const getCurrencySymbol = (currency: Currency, locale: string) => {
  const symbolFontFamily = getCurrencySymbolFontFamily(currency, locale);

  if (symbolFontFamily && checkIsSymbolFontLoaded(currency, locale)) {
    return ARABIC_SYMBOLS[currency.code] + ' ';
  }

  return currency.symbol;
};
